import { styled, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';

const Main = styled('main')(({ theme }) => ({
    ...theme.typography.errorPageContent,
    [theme.breakpoints.up('md')]: {
        marginLeft: '50px',
        marginRight: '50px',
        marginTop: '50px',
    },
    [theme.breakpoints.down('md')]: {
        marginLeft: '25px',
        marginRight: '25px',
        marginTop: '25px',
    },
    [theme.breakpoints.down('sm')]: {
        marginLeft: '10px',
        marginRight: '10px',
        marginTop: '10px',
    }
}));

const ErrorLayout = () => {
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex'}}>
            <CssBaseline />
            <Main theme={theme}>
                <Outlet />
            </Main>
        </Box>
    );
};

export default ErrorLayout;